export const phoneFilter = (phone: string | number | null): string | number | null => {
  if (!phone) return "";

  let cleanPhoneNumber = phone.toString().replace(/\D/g, ''); //Limpiamos caracteres no numericos

  if (cleanPhoneNumber.length === 10) {
    return cleanPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1)-$2-$3');
  }
  if (cleanPhoneNumber.length === 11) {
    return cleanPhoneNumber.replace(/(\d)(\d{3})(\d{3})(\d{4})/, '$1-($2) $3-$4');
  }
  return phone;
}
